/** Photos d'ambiance du restaurant (fournies par le patron) — servies depuis /public/ambiance. */
export const AMBIANCE = {
  cocktails: { url: '/ambiance/cocktails.jpg', alt: 'Cocktails en terrasse', caption: 'Belle soirée de service.' },
  grill: { url: '/ambiance/grill.jpg', alt: 'Grill aux flammes', caption: 'La cuisine tourne.' },
  pancakes: { url: '/ambiance/pancakes.jpg', alt: 'Pancakes aux fruits rouges', caption: 'Bon brunch.' },
  barman: { url: '/ambiance/barman.jpg', alt: 'Barman au shaker', caption: "L'équipe est en place." },
  brunch: { url: '/ambiance/brunch.jpg', alt: 'Salade et jus frais', caption: 'Service du midi.' },
};

/** Photos propres au client (tenant.ambiance_photos) : remplacent les photos par défaut. */
export const applyTenantAmbiance = (tenant) => {
  const own = tenant?.ambiance_photos || {};
  const defaults = { cocktails: '/ambiance/cocktails.jpg', grill: '/ambiance/grill.jpg', pancakes: '/ambiance/pancakes.jpg', barman: '/ambiance/barman.jpg', brunch: '/ambiance/brunch.jpg' };
  Object.keys(AMBIANCE).forEach((k) => { AMBIANCE[k].url = own[k] || defaults[k]; });
};

/** Photo du hero selon le moment de la journée : matin → brunch, midi → salade, soir → cocktails. */
export const heroPhotoForNow = (d = new Date()) => {
  const h = d.getHours();
  if (h < 11) return AMBIANCE.pancakes;
  if (h < 15) return AMBIANCE.brunch;
  if (h < 18) return AMBIANCE.grill;
  return AMBIANCE.cocktails;
};

const RULES = [
  [/pancake|cr[êe]pe|gaufre|dessert|sucr|fruit|brioche|tiramisu|cheesecake|tarte|cookie|muffin|granola|yaourt|açai|acai/i, 'pancakes'],
  [/cocktail|mojito|spritz|boisson|jus|smoothie|limonade|soda|caf[ée]|latte|matcha|th[ée]\b|vin|bi[èe]re|shot|mocktail/i, 'cocktails'],
  [/grill|brochette|viande|steak|burger|poulet|agneau|b[œoe]uf|crevette|gambas|poisson|saumon|thon|barbecue|bbq|ribs|merguez|kefta|entrec[ôo]vous/i, 'grill'],
  [/salade|bowl|brunch|avocado|avocat|toast|tartine|[œoe]uf|egg|houmous|falafel|veggie|v[ée]g/i, 'brunch'],
];
const CYCLE = ['brunch', 'grill', 'pancakes', 'cocktails', 'barman'];

/** Photo par défaut d'un plat : d'abord la photo réelle, sinon une ambiance choisie selon nom + catégorie. */
export const dishPhotoFor = (fiche, index = 0) => {
  if (fiche?.photo_url) return fiche.photo_url;
  const text = `${fiche?.nom_plat || ''} ${fiche?.categorie || ''}`;
  const hit = RULES.find(([re]) => re.test(text));
  return AMBIANCE[hit ? hit[1] : CYCLE[index % CYCLE.length]].url;
};

/** Même chose pour une liste : évite qu'une même ambiance se répète entre plats voisins. */
export const dishPhotosFor = (fiches = []) => {
  const used = new Set();
  return fiches.map((f, i) => {
    let url = dishPhotoFor(f, i);
    if (!f?.photo_url && used.has(url)) {
      const alt = CYCLE.map((k) => AMBIANCE[k].url).find((u) => !used.has(u));
      if (alt) url = alt;
    }
    used.add(url);
    return url;
  });
};
